// stages/AnalysisTeaserStage.js
import React from 'react';

const AnalysisTeaserStage = ({ analysisData, showQuestions }) => {
  return (
    <div className="stage">
      <h2 className="stage-title">Analysis Complete</h2>

      <div className="analysis-teaser">
        <p>We've scanned your file's structure, formulas, and dependencies.</p>

        <div className="teaser-message">
          <p>Answer a few quick questions and we'll tailor the recommendation to how the file is used in practice.</p>
        </div>
      </div>

      <div className="text-center">
        <button
          className="btn-primary"
          onClick={showQuestions}
        >
          Continue to Questions
        </button>
      </div>
    </div>
  );
};

export default AnalysisTeaserStage;